import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

// Components
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import ToClose from "../../components/ToClose/ToClose";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import RadioComponent from "../../components/RadioComponent/RadioComponent";
import Attachment from "../../components/Attachment/Attachment";

// Icons
import { RiFileTextLine } from "react-icons/ri";

// Styles
import styles from "./UploadDocument.module.css";

const UploadDocument = () => {
  const dispatch = useDispatch();
  const [mediaType, setMediaType] = useState("file");
  const [selectedFile, setSelectedFile] = useState(null);

  const handleSave = () => {
    console.log("Uploading:", { mediaType, selectedFile });
    
  };

  const handleClose = () => {
   // Clear selected file
    dispatch(closeModal()); // Close the modal
  };
  const handleCancel = () => {
    setMediaType("file"); // Reset to default type
    setSelectedFile(null); // Clear selected file
     // Close the modal
  };

  return (
    <div className={styles.cardContainer}>
      <div className={styles.header}>
        <HeadingAndIcon icon={<RiFileTextLine />} heading="Upload Document" />
        <ToClose onClose={handleClose} />
      </div>

      <div className={styles.body}>
        <div className={styles.section}>
          <label className={styles.label}>
            Media Type <span>*</span>
          </label>
          <div className={styles.radioGroup}>
            <RadioComponent
              name="media"
              value="file"
              label="File"
              checked={mediaType === "file"}
              onChange={(e) => setMediaType(e.target.value)}
            />
            <RadioComponent
              name="media"
              value="photo"
              label="Photo"
              checked={mediaType === "photo"}
              onChange={(e) => setMediaType(e.target.value)}
            />
          </div>
        </div>

        <div className={styles.section}>
          <Attachment
            label="Upload File / document"
            accept={mediaType === "photo" ? "image/*" : "*"}
            required
            onFileSelect={setSelectedFile}
          />
        </div>

        <div className={styles.actions}>
          <SaveAndCancel
            onSave={handleSave}
            onCancel={handleCancel}
            saveLabel="Save"
          />
        </div>
      </div>
    </div>
  );
};

export default UploadDocument;
